import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductFulfillmentStatus extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateStatus);
  }

  /**
   * Updates stock and delivery time after a variant change.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.detail.data.productId && event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newStatus = event.detail.data.html.querySelector(
      `product-fulfillment-status[data-section-id="${this.dataset.sectionId}"]`
    );

    if (!newStatus) return;

    morph(this, newStatus, { childrenOnly: true });
    this.dataset.variantId = newStatus.dataset.variantId;
  };
}

if (!customElements.get('product-fulfillment-status')) {
  customElements.define('product-fulfillment-status', ProductFulfillmentStatus);
}
